const ORDER = Object.freeze({
  asc: 'ascending',
  dsc: 'descending',
});

// noinspection JSUnusedGlobalSymbols
export default ORDER;
